import {Skeleton, Stack, Typography} from "@mui/material";
import {AsyncSelect} from "src/components/forms";
import {UseFormReturn, useWatch} from "react-hook-form";
import {FormOperacionCLFB, OperacionCLFB} from "../types/types";
import {OperacionCLFBFields} from "../types/fields";
import {HttpCacheOperacion} from "../../../api/httpCacheOperacion";
import React, {useCallback, useEffect, useRef, useState} from "react";
import {OperacionCLFBAgregadosFields, OperacionCLFBAgregadosVista} from "../../../types/clfb";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import {numberFormatter} from "../../../../../utils/formatters/numberFormatter";
import {HttpCLFB} from "../api/HttpCLFB";
import toast from "react-hot-toast";

type DatosAdicionalesProps = {
    formMethods: UseFormReturn<FormOperacionCLFB>
    readOnly?: boolean
    operacion?: OperacionCLFB
    codPais?: number
}

const SeccionCLFBDatosAdicionales = ({ formMethods, readOnly, operacion, codPais }: DatosAdicionalesProps) => {

    const { control } = formMethods
    const [agregados, setAgregados] = useState<OperacionCLFBAgregadosVista[]>([])
    const [loadingAgregados, setLoadingAgregados] = useState<boolean>(false)


    const watchLimiteAgregadoNeto = useWatch({control:control, name:OperacionCLFBFields.AgregadoNeto})
    const watchLimiteAgregadoAbsoluto = useWatch({control:control, name:OperacionCLFBFields.AgregadoAbsoluto})

    useEffect(() => {
        setLoadingAgregados(true)
        HttpCacheOperacion.getAgregados(codPais || 0).then(setAgregados).finally(() => setLoadingAgregados(false))
    }, [codPais])

    const findAgregadoById = useCallback((id?:number) => agregados.find(a => a.id === id)?.agregadoImporte || null, [agregados])

    useEffect(() => {
        if (operacion && operacion.permiteEditarOperacion && Number(watchLimiteAgregadoNeto) != Number(operacion?.agregadoNeto)) {
          const promise = HttpCLFB.updateAgregadoNeto(operacion.id, watchLimiteAgregadoNeto)

          toast.promise(promise, {
            loading: 'Guardando.',
            success: 'Guardado correctamente.',
            error: e => `${e}`
          })
        }
    }, [watchLimiteAgregadoNeto]);

    useEffect(() => {
      if (operacion && operacion.permiteEditarOperacion && Number(watchLimiteAgregadoAbsoluto) != Number(operacion?.agregadoAbsoluto)) {
        const promise = HttpCLFB.updateAgregadAbsoluto(operacion.id, watchLimiteAgregadoAbsoluto)

        toast.promise(promise, {
          loading: 'Guardando.',
          success: 'Guardado correctamente.',
          error: e => `${e}`
        })
      }
    }, [watchLimiteAgregadoAbsoluto]);



    return (
        <TableRow>
            <TableCell>
                <Typography variant="body2">LIMITE AGREGADO</Typography>
            </TableCell>
            <TableCell>
                <Stack direction={'row'}>
                    {
                        readOnly ?
                            <>
                                {
                                  loadingAgregados ?
                                    <Skeleton width="100px" /> :
                                    numberFormatter.toStringWithAmount(findAgregadoById(operacion?.agregadoNeto),'USD ',0)
                                }
                            </> :
                            <AsyncSelect
                                control={control}
                                name={OperacionCLFBFields.AgregadoNeto}
                                label='Limite Agregado Neto'
                                loadOptions={() => Promise.resolve(agregados.filter(a => !a[OperacionCLFBAgregadosFields.Absoluto]))}
                                fullWidth
                                InputProps={{
                                    readOnly: readOnly
                                }}
                                labelSize={'0.75rem'}
                                optionPrefix={'USD '}
                            />
                    }
                </Stack>
            </TableCell>
            <TableCell>
                {
                    readOnly ?
                      <>
                        {
                          loadingAgregados ?
                            <Skeleton width="100px" /> :
                            numberFormatter.toStringWithAmount(findAgregadoById(operacion?.agregadoAbsoluto),'USD ', 0)
                        }
                      </> :
                        <AsyncSelect
                            control={control}
                            name={OperacionCLFBFields.AgregadoAbsoluto}
                            label='Limite Agregado Absoluto'
                            loadOptions={() => Promise.resolve(agregados.filter(a => a[OperacionCLFBAgregadosFields.Absoluto]))}
                            fullWidth
                            InputProps={{
                                readOnly: readOnly
                            }}
                            labelSize={'0.75rem'}
                            optionPrefix={'USD '}
                        />
                }
            </TableCell>
            <TableCell colSpan={8}></TableCell>
        </TableRow>
    )
}

export default SeccionCLFBDatosAdicionales
